import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Custom_Confirm_Modal from "../../Common_Component/Common_Modal/Custom_Confirm_Modal/Custom_Confirm_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  declareResultAPI,
  reverseResultAPI,
} from "../../../utils/apis/matka/result/result";
import { useNavigate } from "react-router-dom";

import { formatDateTime, pannaList, Per_Page_Dropdown, users_type } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State, stores } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";

const Tables = () => {

  const navigate = useNavigate();
  const { id } = Object.fromEntries(new URLSearchParams(window.location.search));


  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const today = new Date();

  const formattedDate =
    today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, "0") +
    String(today.getDate()).padStart(2, "0");

  const [form, setForm] = useState({
    date: new Date().toISOString().split("T")[0],
    store_id: "",
    type: "",
    result: "",
    digit: "",
  });

  // CALCULATE DIGIT
  const calculateDigit = (value) => {

    let sum = 0;

    value.split("").forEach((num) => {
      sum += parseInt(num || 0);
    });

    return sum % 10;
  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    let updated = {
      ...form,
      [name]: value,
    };

    // AUTO DIGIT
    if (name === "result") {

      const digit = value
        ? calculateDigit(value)
        : "";

      updated.digit = digit;
    }

    setForm(updated);
  };


  const declareResult = async (e) => {

    e.preventDefault();

    try {

      const response = await declareResultAPI(form);

      if (
        response?.data?.success ||
        response?.status === 200
      ) {

        alert(
          response?.data?.data ||
          "Result declared successfully"
        );

        // RESET FORM
        setForm({
          date: new Date()
            .toISOString()
            .split("T")[0],
          store_id: "",
          type: "",
          result: "",
          digit: "",
        });

        // REFRESH TABLE
        getDataAll();

      } else {

        alert(
          response?.data?.message ||
          "Something went wrong"
        );
      }

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "Server Error"
      );
    }
  };


  const reverseResult = async () => {

    setModalConfirmShow(false);
    try {
      const response = await reverseResultAPI(confirmModalData?.result_id, confirmModalData?.type);

      if (
        response?.data?.success ||
        response?.status === 200
      ) {
        alert(
          response?.data?.data ||
          "Result reversed successfully"
        );

        // REFRESH TABLE
        getDataAll();

      } else {
        alert(
          response?.data?.message ||
          "Something went wrong"
        );
      }

    } catch (error) {
      console.error(error);
      alert(
        error?.response?.data?.message ||
        "Server Error"
      );
    }

  };


  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalConfirmShow, setModalConfirmShow] = useState(false);
  const [confirmModalData, setConfirmModalData] = useState(null);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [search, setSearch] = useState(formattedDate);
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchDateFrom, setSearchDatefrom] = useState("");
  const [searchStore, setSearchStore] = useState("");

  const [name, setName] = useState("");
  const [contact_no, setContact_no] = useState("");
  const [store, setStore] = useState();


  const getStores = async () => {
    const response = await stores();

    await setStore(response?.data?.data?.data);
  }

  const getDataAll = async () => {
    try {
      const response = await stores(
        searchDateFrom,
      );

      await setData(response?.data?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));


    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
    getStores();
  }, [changeStatus, perPage, reset, modalShow, modalEditShow, currentPage]);



  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const getToday = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const formatDateForPeriod = (date) => date.replaceAll("-", "");

  const [periodPrefix, setPeriodPrefix] = useState(formattedDate);
  const [periodSuffix, setPeriodSuffix] = useState("");



  useEffect(() => {
    if (searchDateFrom) {
      setPeriodPrefix(formatDateForPeriod(searchDateFrom));
      setPeriodSuffix(""); // reset suffix when date changes
    }
  }, [searchDateFrom]);



  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Matka Bid History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={searchDateFrom}
                    min="0001-01-01"
                    max="9999-12-31"   // ✅ ensures only 4-digit year
                    onChange={(e) => {
                      const value = e.target.value;

                      // optional safety (can even remove this) 77777777777777777
                      if (!value) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>




              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}
                >
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setName("");
                    setSearchDatefrom("");
                    setSearchStore("");
                    setReset(!reset);
                  }}
                >
                  Reset
                </Button>
              </div>
              <hr />
            </div>
          </Form>
        </div>

        <div className="card mt-2">

          <div className="card-header">
            <h5>Declare Result</h5>
          </div>

          <div className="card-body">

            <Form onSubmit={declareResult}>

              <div className="row">

                {/* DATE */}
                <div className="col-md-3 mb-3">

                  <label>Date</label>

                  <input
                    type="date"
                    name="date"
                    className="form-control"
                    value={form.date}
                    onChange={handleChange}
                  />

                </div>



                {/* STORE */}
                <div className="col-md-3 mb-3">

                  <label>Game</label>

                  <select
                    name="store_id"
                    className="form-control"
                    value={form.store_id}
                    onChange={handleChange}
                  >

                    <option value="">
                      Select Game
                    </option>

                    {data?.data?.map((item) => (

                      <option
                        key={item.value}
                        value={item.value}
                      >
                        {item.label}
                      </option>

                    ))}

                  </select>

                </div>



                {/* SESSION */}
                <div className="col-md-3 mb-3">

                  <label>Session</label>

                  <select
                    name="type"
                    className="form-control"
                    value={form.type}
                    onChange={handleChange}
                  >

                    <option value="">
                      Select Session
                    </option>

                    <option value="open">
                      Open
                    </option>

                    <option value="close">
                      Close
                    </option>

                  </select>

                </div>



                {/* PANNA */}
                <div className="col-md-3 mb-3">

                  <label>Panna</label>

                  <Select
                    options={pannaList.map((item) => ({
                      label: item,
                      value: item,
                    }))}

                    value={
                      form.result
                        ? {
                          label: form.result,
                          value: form.result,
                        }
                        : null
                    }

                    onChange={(selected) => {

                      const value = selected?.value || "";

                      let sum = 0;

                      value.split("").forEach((num) => {
                        sum += parseInt(num || 0);
                      });

                      const digit = sum % 10;

                      setForm((prev) => ({
                        ...prev,
                        result: value,
                        digit: value ? digit : "",
                      }));
                    }}

                    placeholder="Select Panna"

                    isSearchable

                    className="react-select-container"

                    classNamePrefix="react-select"
                  />

                </div>



                {/* DIGIT */}
                <div className="col-md-3 mb-3">

                  <label>Digit</label>

                  <input
                    type="text"
                    className="form-control"
                    value={form.digit}
                    readOnly
                  />

                </div>



                {/* BUTTONS */}
                <div className="col-md-12 mt-3">

                  <button
                    type="submit"
                    className="btn btn-primary me-2"
                  >
                    Declare Result
                  </button>



                </div>

              </div>

            </Form>

          </div>

        </div>

        <div class="row">
          <div class="col-lg-6 text text-white mt-2">
            <h3><b>{data?.selectedDate}</b></h3>
            <h3><b>{data?.todayDay}</b></h3>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Market Name</th>
                      <th>Open Time</th>
                      <th>Open Result</th>
                      <th>Close Time</th>
                      <th>Close Result</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.length > 0 ? (
                      data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            {/* <td>{index + 1}</td> */}
                            <td>
                              {d?.label ?? "-"}
                            </td>
                            <td>
                              {d?.open_time ?? "-"}
                            </td>
                            <td>
                              {d?.result?.open_time ?? "-"}
                              <br />
                              {d?.result?.open_time && (
                                <>
                                  <button
                                    className="btn btn-primary btn-sm mt-1"
                                    onClick={() =>
                                      navigate(
                                        `/matka-bid-history?from=${data?.selectedDate}&store_id=${d.value}&only_win=true&type=open`
                                      )
                                    }
                                  >
                                    Show Winners
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm mt-1 mx-3"
                                    onClick={() => {
                                      setConfirmModalData({ result_id: d?.result?.id, type: "open" });
                                      setModalConfirmShow(true);
                                    }}
                                  >
                                    Result Reverse
                                  </button>
                                </>
                              )}
                            </td>
                            <td>
                              {d?.close_time ?? "-"}

                            </td>
                            <td>
                              {d?.result?.close_time ?? "-"}
                              <br />
                              {d?.result?.close_time && (
                                <>
                                  <button
                                    className="btn btn-primary btn-sm mt-1"
                                    onClick={() =>
                                      navigate(
                                        `/matka-bid-history?from=${data?.selectedDate}&store_id=${d.value}&only_win=true&type=close`
                                      )
                                    }
                                  >
                                    Show Winners
                                  </button>

                                  <button
                                    className="btn btn-primary btn-sm mt-1 mx-3"
                                    onClick={() => {
                                      setConfirmModalData({ result_id: d?.result?.id, type: "close" });
                                      setModalConfirmShow(true);
                                    }}
                                  >
                                    Result Reverse
                                  </button>
                                </>
                              )}

                            </td>


                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>


      <Custom_Confirm_Modal
        heading={"Confirm Reverse Result"}
        title={"Are you sure you want to reverse this result?"}
        show={modalConfirmShow}
        handleFunction={reverseResult}
        onHide={() => setModalConfirmShow(false)}
      />
    </>
  );
};
export default Tables;
